var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgValuation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C10.3431 12.5 9 11.6046 9 10.5C9 9.39543 10.3431 8.5 12 8.5M12 12.5C13.6568 12.5 15 13.3954 15 14.5C15 15.6046 13.6569 16.5 12 16.5M12 12.5V8.5M12 12.5L12 16.5M12 8.5C13.1104 8.5 14.0799 8.9022 14.5986 9.5M12 8.5V7.5M12 16.5L12 17.5M12 16.5C10.8896 16.5 9.92007 16.0978 9.40137 15.5",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgValuation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/valuation.c35fb837.svg";
export { ForwardRef as ReactComponent };